import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { ChatV2Routes } from '../features/chat-v2';

const router = createBrowserRouter([
    {
        path: '/*',
        element: <ChatV2Routes />,
    },
]);

export const Router = () => {
    return <RouterProvider router={router} />;
};
